import React, { useEffect, useState, useRef } from 'react';
import { Row, Col, Card, Button, Spinner, Table, Modal } from 'react-bootstrap';
import HtmlHead from 'components/html-head/HtmlHead';
import { useSelector, connect } from 'react-redux';
import Loading from 'components/loading/Loading';
import { useMount } from 'ahooks';
import { mostraDettagli, nascondiDettagli, caricamentoDettagli as setCaricamento } from 'features/99/schedeTecniche/schedeSlice';

import { richiediDati, richiediDettagli } from './funzioni';

const Tile = ({ Articolo, Descrizione, CodArticoloCliente, onOpen }) => (
  <Card className="h-100" onClick={onOpen}>
    <Card.Body>
      <Card.Title>
        <p className="text text-primary d-inline h4">{Articolo}</p>
      </Card.Title>
      <Card.Subtitle className="mb-2">{CodArticoloCliente}</Card.Subtitle>
      <Card.Text>{Descrizione}</Card.Text>
    </Card.Body>
  </Card>
);

const ModaleDettagli = connect()(({ dispatch }) => {
  const { mostraDettagli: mostraPopup, currentScheda, caricamentoDettagli, dettagliScheda } = useSelector((state) => state.schede99);

  useEffect(() => {
    richiediDettagli();
  }, [currentScheda]);

  return (
    <Modal
      show={mostraPopup}
      onHide={() => {
        dispatch(nascondiDettagli());
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <h5 className="text-primary">Details for '{currentScheda?.Articolo}'</h5>
          <p className="fs-10">{currentScheda?.CodArticoloCliente}</p>
          <p className="fs-10">{currentScheda?.Descrizione}</p>
        </Modal.Title>
      </Modal.Header>
      {caricamentoDettagli ? (
        <div className="w-100 d-flex align-items-center justify-content-center" style={{ height: 200 }}>
          <Spinner animation="border" />
        </div>
      ) : (
        <Modal.Body>
          <dl>
            {dettagliScheda.map((dettaglio) => {
              return (
                <>
                  <dt>{dettaglio?.Campo}</dt>
                  <dd>{dettaglio?.Valore || '/'}</dd>
                  <hr />
                </>
              );
            })}
          </dl>
        </Modal.Body>
      )}
    </Modal>
  );
});

const Schede99 = ({ dispatch }) => {
  const { schedeTecniche, mostraDettagli: mostraPopup, currentScheda, caricamentoInCorso } = useSelector((state) => state.schede99);

  useMount(richiediDati);

  // type scheda {
  //   IdScheda: number;
  //   Articolo: string;
  //   CodArticoloCliente: string;
  //   Descrizione: string;
  // }

  const title = 'Technical sheets';
  const description = 'View technical sheets';

  if (caricamentoInCorso) {
    return (
      <>
        <HtmlHead title={title} description={description} />
        <Loading />
      </>
    );
  }

  return (
    <>
      <HtmlHead title={title} description={description} />
      <Row>
        <Col>
          {/* Title Start */}
          <section className="scroll-section" id="title">
            <div className="page-title-container">
              <h1 className="mb-0 pb-0 display-4">{title}</h1>
            </div>
          </section>
          {/* Title End */}
          <section className="scroll-section" id="lista-articoli">
            {schedeTecniche.length ? (
              <Row>
                {schedeTecniche.map((scheda, i) => {
                  return (
                    <Col className="mb-3 mb-md-4" md={6} sm={12} xl={4} key={i}>
                      <Tile {...scheda} onOpen={() => dispatch(mostraDettagli(scheda))} />
                    </Col>
                  );
                })}
              </Row>
            ) : (
              <h3>No data</h3>
            )}
          </section>
          {/* <section className="scroll-section" id="lista-articoli">
            {schedeTecniche.map((scheda, i) => {
              return <Tile key={i} {...scheda} />;
            })}
          </section> */}
          <ModaleDettagli />
        </Col>
      </Row>
    </>
  );
};

export default connect()(Schede99);
